<div >
     <div>
       <ol class="wizard-steps list-group shadow-sm mb-3">
         <li
           *ngFor="let item of wizardObj.steps; let i = index"
           [class]="
               item.step === activeStep
               ? 'list-group-item active'
               : activeStep > item.step
               ? 'list-group-item done'
               : 'list-group-item'
           "
         >
           <span>{{ getTranslator(item.text) }}</span>
         </li>
       </ol>
     </div>
     <div *ngIf="pageType !== 'driver'" class="card shadow-sm rounded-0 border-0">
       <div class="card-body">
         <h3 class="card-title h5" [innerHTML]="'Wiz_Downloads' | translator:'base'"></h3>
         <ul>
           <li *ngIf="pageType === customerType.AH || pageType === 'all'">
             <button
               (click)="openDocument('PSPMotorCarrierEnrollment')"
               target="_blank"
               class="btn btn-link"
               [title]="'MAHEnrollAgreement' | translator:'base'"
               [innerHTML]="'MAHEnrollAgreement' | translator:'base'"
               name="openMAHEnrollAgreement"
               id="openMAHEnrollAgreement"
               tabindex="0"
             >PSP Monthly Account Holder Enrollment Agreement</button>
           </li>
           <li *ngIf="pageType === customerType.ISP || pageType === 'all'">
             <button
               (click)="openDocument('ISPAccountHolderAgreement')"
               target="_blank"
               class="btn btn-link"
               [title]="'ISPEnrollAgreement' | translator:'base'"
               [innerHTML]="'ISPEnrollAgreement' | translator:'base'"
               name="openISPEnrollAgreement"
               id="openISPEnrollAgreement"
               tabindex="0"
             >PSP Industry Service Provider Enrollment Agreement</button>
           </li>
           <li>
             <button
               class="btn btn-link"
               [innerHTML]="'DisclosureAndAuth' | translator:'base'"
               (click)="openDocument('PSPDisclosureandAuthorizationForm')"
               target="_blank"
               [title]="'DisclosureAndAuth' | translator:'base'"
               tabindex="0"
               id="openDandA"
               name="openDandA"
             >Disclosure and Authorization Form</button>
           </li>
         </ul>
       </div>
     </div>
   </div>